import React from 'react';
import { Box, Flex, useTokens } from '@mezzoforte/forge';

const { colors } = useTokens.huutokaupat;

export interface LoggedInIconProps {
  readonly initials: string;
  readonly background: string;
}

export function LoggedInIcon({ initials, background }: LoggedInIconProps) {
  return (
    <Flex
      background={background}
      color={colors.textInvert}
      minWidth="24px"
      minHeight="24px"
      borderRadius="50%"
      fontSize="10px"
      justifyContent="center"
      alignItems="center"
    >
      <Box>{initials}</Box>
    </Flex>
  );
}
